import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  mode: 'light',
  palette: {
    primary: {
      main: '#DE0813',
      light: '#f01e18',
      dark: '#d10009',
      contrastText: '#fff',
    },
    secondary: {
      main: '#414141',
      light: '#606060',
      dark: '#202020',
      contrastText: '#fff',
    },
    text: {
        primary: '#000000',
        secondary: '#5c5c59',
        disabled: 'rgba(39,36,36,0.38)',
      },
    error: {
      main: '#FF1744',
      light: '#f35a6b',
      light: '#ff0026',
      contrastText: '#000',
    },
    background: {
        paper: '#FFF',
        default:'#FFF'
    }
  },
  shape: {
    borderRadius: 4,
  },
  spacing: 8,
});

export default theme;
/*
Error

palette.error.light

#ef5350

palette.error.main

#d32f2f

palette.error.dark

#c62828

Warning

palette.warning.light

#ff9800

palette.warning.main

#ed6c02

palette.warning.dark

#e65100

Info

palette.info.light

#03a9f4

palette.info.main

#0288d1

palette.info.dark

#01579b

Success

palette.success.light

#4caf50

palette.success.main

#2e7d32

palette.success.dark

#1b5e20
*/